export default {
  data() {
    return {
      isShowSuccess: false,
      isShowError: false
    }
  },
  methods: {
    onCheckedSuccess() {
      this.isShowSuccess = !this.isShowSuccess
    },
    enterSuccess() {
      setTimeout(() => {
        this.isShowSuccess = false
      }, 3000)
    },
    onCheckedError() {
      this.isShowError = !this.isShowError
    },
    enterError() {
      setTimeout(() => {
        this.isShowError = false
      }, 3000)
    }
  }
}
